import React, { useState } from 'react'
import Button from '../../../button';
import { toMoney } from 'vanilla-masker'
import api from '../../../../services/api';
import toast from 'react-hot-toast';
import GhostButton from '../../../ghost-button';

const PlansSection = (props) => {
  console.log(props.subscriptionData)
  const [isCancelingSubscription, setIsCancelingSubscription] = useState(false)

  const openPurchaseSubscription = () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'PURCHASE_SUBSCRIPTION',
    }))
  }

  const restorePastPurchases = () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'PURCHASE_RESTORE',
    }))
  }

  const cancelPlanHandler = async () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'PURCHASE_CANCEL',
    }))
    // try {
    //   setIsCancelingSubscription(true)
      
    //   const hash = window.localStorage.getItem('@cov/hash')
    //   await api.delete(`/app/plano/${hash}`)
    //   props.checkIfUserHasScubscription()

    //   if (props.isUserInFreeTrial) {
    //     if (window.in_native_app) {
    //       window.ReactNativeWebView.postMessage(JSON.stringify({
    //         type: 'CLEAR_DATABASE',
    //       }))
    //     }
    //   }
      
    //   props.setShowCancelationSuccessMessage(true)
    //   dismissCancelHandler()
    // } catch {
    //   toast.error("Não foi possível cancelar sua assinatura, por favor tente novamente mais tarde.")
    // } finally {
    //   setIsCancelingSubscription(false)
    // }
  }

  // if (props.showConfirmCancelPlan) {
  //   return (
  //     <div className='w-full'>
  //       <h3 className='font-semibold'>Minha assinatura</h3>
  //       <div className='p-4 mt-4 border rounded-lg border-slate-300'>
  //         <h4 className='text-2xl font-bold'>Cancelar assinatura</h4>
  //         <p>Tem certeza que deseja cancelar sua assinatura?</p>
  //         {props.isUserInFreeTrial ? (
  //           <p className='mt-1'>Ao cancelar sua assinatura, todos os livros baixados serão removidos.</p>
  //         ): null}

  //         <div className='w-full flex flex-col justify-center items-center mt-8 space-y-4'>
  //           <Button onClick={dismissCancelHandler}>Não</Button>

  //           <GhostButton
  //             loading={isCancelingSubscription}
  //             disabled={isCancelingSubscription}
  //             onClick={cancelPlanHandler}
  //           >
  //             Sim
  //           </GhostButton>
  //         </div>

  //         <p className='mt-2 text-sm'>Ao cancelar sua assinatura, ela permanecerá ativa até o fim do período vigente, mas não será renovada posteriormente.</p>
  //       </div>
  //     </div>
  //   )
  // }

  if (!props.subscriptionData) {
    return (
      <div className='w-full'>
        <p className='text-xl text-green-primary text-center font-bold'>Assinatura cancelada</p>
        <p className='mt-2 text-center'>Você não receberá novas cobranças. Continue aproveitando os livros que você adquiriu. Não esqueça de fazer download para guardá-los para sempre. Para voltar a receber novos livros todos os meses, faça uma nova assinatura.</p>

        {!props.subscriptionData ? (
          <button
            onClick={openPurchaseSubscription}
            className="w-full h-10 text-blue-secondary bg-yellow-primary focus:ring-0 rounded-full text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none font-bold mt-6"
          >
            Assinar
          </button>
        ): null}

        <button
          onClick={restorePastPurchases}
          className="w-full h-10 text-blue-secondary bg-yellow-primary focus:ring-0 rounded-full text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none font-bold mt-6"
        >
          Restaurar compras antigas
        </button>
      </div>
    )
  }

  return (
    <div className='w-full'>
      <h3 className='font-semibold'>Minha assinatura</h3>
      <div className="w-full grid grid-cols-1 gap-x-4 text-sm mt-4">
        <div className="w-full p-6 rounded-2xl bg-blue-100 mt-6">
          <p className="mt-4 text-lg text-gray-600">
            <b>Dois novos livros por mês</b>
            <br />
            para ler e ouvir.
          </p>

          <p className="mt-4 text-lg text-gray-600">
            <b>Uma biblioteca de presente</b>
            <br />
            na efetivação da assinatura.
          </p>

          <p className="mt-4 text-lg text-gray-600">
            <b>Leia online ou offline</b>
            <br />e guarde seus livros para sempre.
          </p>

          <p className="mt-4 text-lg text-gray-600">
            <b>Cancele quando quiser.</b>
          </p>
        </div>
        {/* <div className={clsx("w-full bg-slate-200 rounded-lg border-2 border-transparent flex flex-col justify-start items-stretch p-4", props.currentPlanId && "border-green-primary")}>
          <div className='flex flex-col justify-center items-center space-y-2'>
            <div className="flex flex-row justify-center items-center">
              <span className="font-black text-xl">
                {toMoney(props.plan.valor, {
                  unit: 'R$'
                })} - {props.plan.plano}
              </span>
            </div>

            <p className='text-center text-lg'>Sua assinatura está ativa. Você pode fazer o cancelamento quando quiser. Se preferir, pode tirar suas dúvidas pelo Fale conosco antes de cancelar</p>
          </div>

          {props.plan?.beneficios?.length ? (
            <div className="text-left mt-3">
              <p className="text-lg font-bold">Benefícios</p>

              <div className='grid grid-cols-2 gap-x-4'>
                {props.plan?.beneficios?.map(benefit => (
                  <div key={benefit.beneficio}>
                    <p className='text-xs'>{benefit.beneficio}</p>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div> */}

        {!!props.subscriptionData ? (
          <button
            onClick={cancelPlanHandler}
            className="w-full h-10 text-red-500 bg-transparent underline focus:ring-0 rounded-full px-5 py-2.5 me-2 mb-2 focus:outline-none font-bold text-lg"
          >
            Cancelar
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default PlansSection
